interface resultItem {
  list: Array<any>
  num: number
  size: number
  total: number
  has_next: boolean
}

interface VuexState {
  index: number
  result: Array<resultItem>
  resultLoading: boolean
  sheetList: Array<any>
  styleId: string
  producerId: string
  id: number
  styleListOpen: boolean
  producerListOpen: boolean
  order: number
  sort: number
}
const state = (): VuexState => ({
  index: 0, // 当前选择的是哪一个
  result: [], // 筛选结果列表
  resultLoading: false, // 自选模式列表loading
  sheetList: [], // 片单列表
  styleId: '-1', // 风格id
  producerId: '-1', // 出品id
  id: 0, // 片单id
  styleListOpen: false, // 是否展示风格列表
  producerListOpen: false, // 是否展开出品方列表
  order: 2, // 当前按什么类型排序 2: 播放量 4: 评分 6: 时间
  sort: 0, // 升降序： 降序，不做升序
})
export default state
